import { listCreditResolver } from './pages/list-credit/at-list-credit.resolver';
import {
  agencesClientResolver,
  gestionnairesClientResolver,
  listClientResolver,
} from './pages/list-client/at-list-client.resolver';
import {
  comptesClientResolver,
  syntheseComptesClientResolver,
  ficheClientResolver,
  historiqueClientResolver,
  situationDossiersResolver,
} from './pages/fiche-client/at-fiche-client.resolver';
import { Route } from '@angular/router';
import { roleGuard } from '@/core/guards/role.guard';
import { UserRole } from '@/core/models/user.model';
import { detailCreditResolver } from './pages/fiche-credit/at-fiche-credit.resolver';
import { planificationResolver } from './pages/planification-action/planification-action.resolver';
import { intervenantsResolver } from './pages/intervenants/at-intervenants.resolver';
import { ACCESS_TRACK_ROLES } from '@/core/constants/access-roles';


export const accessTrackRoutes: Route = {
  path: 'access-track',
  children: [
    {
      path: 'dashboard',
      canActivate: [roleGuard([...ACCESS_TRACK_ROLES])],
      loadComponent: () =>
        import('./pages/dashboard/at-dashboard.component').then(
          (m) => m.AtDashboardComponent,
        ),
    },
    {
      path: 'vue-client',
      canActivate: [roleGuard([...ACCESS_TRACK_ROLES])],
      resolve: {
        data: listClientResolver,
        agences: agencesClientResolver,
        gestionnaires: gestionnairesClientResolver,
      },
      loadComponent: () =>
        import('./pages/list-client/at-list-client.component').then(
          (m) => m.AtListClientComponent,
        ),
    },
    {
      path: 'vue-credit',
      canActivate: [roleGuard([...ACCESS_TRACK_ROLES])],
      resolve: { data: listCreditResolver },
      loadComponent: () =>
        import('./pages/list-credit/at-list-credit.component').then(
          (m) => m.AtListCreditComponent,
        ),
    },
    {
      path: 'vue-client/:id',
      canActivate: [roleGuard([...ACCESS_TRACK_ROLES])],
      resolve: {
        adherent: ficheClientResolver,
        historique: historiqueClientResolver,
        comptesClient: comptesClientResolver,
        syntheseComptes: syntheseComptesClientResolver,
        situationDossiers: situationDossiersResolver
      },
      loadComponent: () =>
        import('./pages/fiche-client/at-fiche-client.component').then(
          (m) => m.AtFicheClientComponent,
        ),
    },
    {
      path: 'vue-credit/:numDossier',
      canActivate: [roleGuard([...ACCESS_TRACK_ROLES])],
      resolve: { fullDossier: detailCreditResolver },
      loadComponent: () =>
        import('./pages/fiche-credit/at-fiche-credit.component').then(
          (m) => m.AtFicheCreditComponent,
        ),
    },
    {
      path: 'reportings',
      canActivate: [roleGuard([...ACCESS_TRACK_ROLES])],
      loadComponent: () =>
        import('./pages/reportings/at-reportings.component').then(
          (m) => m.AtReportingsComponent,
        ),
    },
    {
      path: 'intervenants',
      canActivate: [roleGuard([...ACCESS_TRACK_ROLES])],
      resolve: { intervenants: intervenantsResolver },
      loadComponent: () =>
        import('./pages/intervenants/at-intervenants.component').then(
          (m) => m.AtIntervenantsComponent,
        ),
    },
    {
      path: 'intervenants/:id',
      canActivate: [roleGuard([...ACCESS_TRACK_ROLES])],
      loadComponent: () =>
        import('./pages/detail-intervenant/detail-intervenant.component').then(
          (m) => m.DetailIntervenantComponent,
        ),
    },
    {
      path: 'planification',
      canActivate: [roleGuard([...ACCESS_TRACK_ROLES])],
      resolve: { data: planificationResolver },
      loadComponent: () =>
        import('./pages/planification-action/planification-action.component').then(
          (m) => m.PlanificationActionComponent
        ),
    },
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'vue-client',
    },
  ],
};
